<app-sales-credit-number [creditNumber]="data().number" [data]="data()" *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>
<div class="container section__authorization h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="small__padBot">
        <div class="mainInfo">
          <h1>{{ 'Autorización para solicitar Reportes de Crédito' | termReplace }}</h1>
          <p>Por favor, desplazate a través de la pagina para ir leyendo la autorización. Al final, podrás hacer la firma digital.</p>
        </div>

        <div class="backgroundArrow">
          <div class="arrowSvg">
            <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.5">
                <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
              </g>
              <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div class="authorizationBlock">
          <!-- <p-scrollPanel id="agreement-container" (scroll)="isTheEndOfAgreement()">
            <div class="authorization__text">
              <div class="authorization__textCont">
                <div class="authorization__textHtml" [innerHTML]="authorizationHTML | safeHtml"></div>
              </div>
              <div class="authorization__textBtn" *ngIf="authorizationHTML">
                <button pButton pRipple label="Autorizar" icon="pi pi-pencil" iconPos="right" class="p-button-primary p-button-noShadow p-button-raised p-button-rounded w-full" (click)="visibleSigningModal=true" [disabled]="!isTheEndOfAgreement()"></button>
              </div>
            </div>
          </p-scrollPanel> -->

          <div id="agreement-container" class="p-scrollpanel overflow-y-auto" (scroll)="isTheEndOfAgreement()">
            <div class="authorization__loading" *ngIf="!authorizationHTML">
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
              <span>Cargando acuerdo...</span>
            </div>

            <div class="authorization__text" *ngIf="authorizationHTML">
              <div class="authorization__textCont">
                <div class="authorization__textHtml" [innerHTML]="authorizationHTML | safeHtml"></div>
              </div>
              <div class="authorization__textBtn">
                <button pButton pRipple label="Autorizar" icon="pi pi-pencil" iconPos="right" class="p-button-primary p-button-noShadow p-button-raised p-button-rounded w-full" (click)="visibleSigningModal=true" [disabled]="!isTheEndOfAgreement()"></button>
              </div>
            </div>
          </div>

          <div class="swipeAnimation" [ngClass]="{ 'active': !isTheEndOfAgreement() }">
            <div class="swipeAnimation__text" *ngIf="authorizationHTML">
              <p class="md:hidden">Usa el dedo para moverte hacia abajo en el documento</p>
              <p class="hidden md:block text-center">Para moverte hacía abajo usa el scroll de la derecha</p>
            </div>
            <div class="swipeAnimation__content md:hidden">
              <div class="path"></div>
              <div class="hand-icon">
                <svg width="50" height="46" viewBox="0 0 50 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="svgStroke--primary" d="M45.9041 26.7683C48.0559 22.805 46.7944 17.9368 43.0895 15.9253L38.6954 13.5397C38.6523 13.5163 38.6092 13.4929 38.5661 13.4695C38.5231 13.4461 38.48 13.4227 38.4369 13.3993L31.0271 9.37649C29.2609 8.41755 27.0674 9.06736 26.1085 10.8336C25.1495 12.5999 25.7993 14.7934 27.5656 15.7523C25.7993 14.7934 23.6059 15.4432 22.6469 17.2095C21.688 18.9758 22.3378 21.1692 24.1041 22.1282C22.3378 21.1692 20.1443 21.8191 19.1854 23.5853C18.2265 25.3516 18.8763 27.5451 20.6426 28.504L8.19242 21.7447C6.42614 20.7858 4.23267 21.4356 3.27373 23.2018C2.3148 24.9681 2.96461 27.1616 4.73089 28.1205L24.5908 38.9027C24.6339 38.9261 24.6769 38.9495 24.72 38.9729C24.7631 38.9963 24.8062 39.0197 24.8493 39.0431L29.2434 41.4287C32.9483 43.4401 37.7181 41.8463 39.8698 37.883L43.5185 31.1625" stroke="#000" stroke-width="4" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="backInnerButton" *ngIf="getCanCancelRequest()">
          <app-sales-cancel-request></app-sales-cancel-request>
        </div>
      </article>
    </div>
  </div>
</div>

<!-- TÉRMINOS Y CONDICIONES MODAL -->
<p-dialog [(visible)]="visibleAcceptTermsModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Aviso</h2>
          <p>Es importante que puedas aceptar los <a href="https://storage.googleapis.com/stila-documentos/terminosycondiciones.pdf" target="_blank"><strong>Términos y Condiciones</strong></a> y la cláusula de medios electrónicos (tales como NIP) para que puedas continuar.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Acepto" icon="pi pi-check" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="acceptLoanTerms()"></button>
          <div class="dialog__btnFloat">
            <p-button label="No acepto" [text]="true" [plain]="true" (click)="notAcceptLoanTerms()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- SMS MODAL -->
<p-dialog [visible]="visibleFirstSentCodeMessageModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Importante</h2>
          <p *ngIf="sentCode"><span [innerHTML]="messageOtpServiceFirstSend"></span> <span *ngIf="visibleFirstSentCodeMessageModal">Lo necesitarás mas adelante al momento de autorizar.</span></p>
          <p *ngIf="!sentCode">Hemos tenido un problema. No te preocupes. Puedes ir leyendo la autorización y lo reintentamos más adelante.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Continuar" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleFirstSentCodeMessageModal=false;"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- SECOND SEND MODAL -->
<p-dialog [visible]="visibleRetriesSentCodeMessageModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Importante</h2>
          <p *ngIf="!sentCode">Hemos tenido un problema para enviar el código. Vuelva a intentarlo por favor.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Reintentar" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="closeAllModals(); visibleSigningModal=true;"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- AUTORIZACIÓN MODAL -->
<p-dialog [(visible)]="visibleSigningModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Confirmación</h2>
          <p [innerHTML]="messageOtpService"></p>
        </div>
        <div class="dialog__form">
          <form [formGroup]="form" (ngSubmit)="authorize()">
            <div class="form__group form__group--codeNumber" [ngClass]="{'form__error': submitted && f['code'].errors}">
              <input pInputText type="text" formControlName="code" maxlength="4">

              <span class="form__msgError form__msgError--center" *ngIf=" (submitted ||  f['code'].touched ) && f['code'].errors">
                <small class="p-error" *ngIf="f['code'].getError('required')">{{ "El Código" | required }}</small>
                <small class="p-error" *ngIf="f['code'].getError('invalid')">{{ "El Código" | invalid }}</small>
              </span>

              <span class="form__msgValidate form__msgValidate--center" *ngIf="f['code'].pending">
                <small class="p-validate">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>Validando código...</span>
                </small>
              </span>
            </div>
            <button pButton pRipple type="submit" label="Autorizar" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="form.invalid"></button>
          </form>
        </div>

        <div class="dialog__ref" *ngIf="!timeFinished()">
          <p *ngIf="sentCode">Si no has recibido nada, tranquilo, puede tardar hasta 2 minutos. Si una vez transcurrido el tiempo no has obtenido el código, podrás reintentar.</p>
          <p *ngIf="!sentCode">Vamos a esperar un poco más. Una vez transcurrido el tiempo, podrás intentarlo nuevamente presionando el botón “Reenviar código”</p>
        </div>

        <div class="dialog__block" *ngIf="timeNewCodeSending">
          <p class="timeWait" *ngIf="!timeFinished() && currentRetries < maxRetries">
            Tiempo para el próximo reintento:
            <br>
            {{ timeNewCodeSending.minutes }} minutos, {{timeNewCodeSending.seconds}} segundos
          </p>

          <div class="refreshBtnText" *ngIf="timeFinished()">
            <div class="refreshBtnText__item">
              <p-button styleClass="blue" label="Reenviar código" icon="pi pi-sync pi-small" iconPos="right" [text]="true" [plain]="true" (click)="showOptionesSend()" [loading]="loading"></p-button>
            </div>

            <div class="refreshBtnText__item" *ngIf="viewValidateButtonWithDocument()">
              <div class="separator"><span>O</span></div>

              <p-button styleClass="blue" label="Realizar validación con el documento" icon="pi pi-id-card pi-big" iconPos="right" [text]="true" [plain]="true" *ngIf="timeFinished()" (click)="showModal()"></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- INGRESAR DOCUMENTO MODAL -->
<p-dialog [(visible)]="visibleCodeModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <form [formGroup]="formCode" (ngSubmit)="onSearchCode()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2>Validación con documento</h2>
            <p>Si no has recibido el código aún, te invitamos a introducir el <strong>documento de identidad</strong>.</p>
          </div>
          <div class="dialog__form">
            <div class="form__group form__group--simpleNumber fWidth" [ngClass]="{'form__error': submitted && fc['document_number'].errors}">
              <input pInputText type="text" formControlName="document_number" appNoSpaces>

              <span class="form__msgError" *ngIf=" (submitted || fc['document_number'].touched)  && fc['document_number'].errors">
                <small class="p-error" *ngIf="fc['document_number'].getError('required')">{{ "El Documento" | required }}</small>
              </span>

              <span class="form__msgValidate form__msgValidate--center" *ngIf="fc['document_number'].pending">
                <small class="p-validate">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span>Validando documento...</span>
                </small>
              </span>
            </div>
          </div>
          <div class="dialog__btn nonePad">
            <button pButton pRipple type="submit" label="Buscar" icon="pi pi-search" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="loading" [disabled]="formCode.invalid"></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>


<!-- ERROR DOCUMENTO MODAL-->
<p-dialog [(visible)]="visibleErrorIDModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__icon">
          <span>
            <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.25 50.75C30.25 49.3576 30.8031 48.0223 31.7877 47.0377C32.7723 46.0531 34.1076 45.5 35.5 45.5C36.8924 45.5 38.2277 46.0531 39.2123 47.0377C40.1969 48.0223 40.75 49.3576 40.75 50.75C40.75 52.1424 40.1969 53.4777 39.2123 54.4623C38.2277 55.4469 36.8924 56 35.5 56C34.1076 56 32.7723 55.4469 31.7877 54.4623C30.8031 53.4777 30.25 52.1424 30.25 50.75ZM32.056 16.87C32.2021 16.063 32.627 15.333 33.2564 14.8073C33.8858 14.2816 34.6799 13.9936 35.5 13.9936C36.3201 13.9936 37.1142 14.2816 37.7436 14.8073C38.373 15.333 38.7979 16.063 38.944 16.87L39 17.5V35L38.944 35.63C38.7979 36.437 38.373 37.167 37.7436 37.6927C37.1142 38.2184 36.3201 38.5064 35.5 38.5064C34.6799 38.5064 33.8858 38.2184 33.2564 37.6927C32.627 37.167 32.2021 36.437 32.056 35.63L32 35V17.5L32.056 16.87ZM70.5 35C70.5 44.2826 66.8125 53.185 60.2487 59.7487C53.685 66.3125 44.7826 70 35.5 70C26.2174 70 17.315 66.3125 10.7513 59.7487C4.18749 53.185 0.5 44.2826 0.5 35C0.5 25.7174 4.18749 16.815 10.7513 10.2513C17.315 3.68749 26.2174 0 35.5 0C44.7826 0 53.685 3.68749 60.2487 10.2513C66.8125 16.815 70.5 25.7174 70.5 35ZM63.5 35C63.5 27.5739 60.55 20.452 55.299 15.201C50.048 9.94999 42.9261 7 35.5 7C28.0739 7 20.952 9.94999 15.701 15.201C10.45 20.452 7.5 27.5739 7.5 35C7.5 42.4261 10.45 49.548 15.701 54.799C20.952 60.05 28.0739 63 35.5 63C42.9261 63 50.048 60.05 55.299 54.799C60.55 49.548 63.5 42.4261 63.5 35Z" fill="#E70F47"/>
            </svg>
          </span>
        </div>
        <div class="dialog__info dialog__info--error">
          <h2>No pudimos validar el documento</h2>
          <p>Verificá que los datos ingresados sean correctos e intentá nuevamente.</p>
          <p class="pt-20">Si el problema persiste, comunicate con soporte para ayudarte a resolverlo.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Reintentar" icon="pi pi-refresh" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onRetryID()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- REENVIO DE CÓDIGO MODAL -->
<p-dialog [(visible)]="showOtpServiceModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Reenvío del codigo</h2>
          <p>En caso de no poder recibir el <strong>codigo</strong> con el método seleccionado, puede elegir otra opción de envío:</p>
        </div>

        <div class="dialog__form">
          <div class="form__radio form__radio--center">
            <div class="form__radioItem" *ngFor="let option of otpServicesOptions">
              <p-radioButton [inputId]="option.value" name="phoneType" [value]="option.value" [(ngModel)]="selectedOtpService"></p-radioButton>
              <label [for]="option.value">{{ option.label }}</label>
            </div>
          </div>
        </div>

        <div class="dialog__btn">
          <button pButton pRipple label="Reenviar" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="!selectedOtpService" (click)="onSelectedOtpServiceAndSend(true)"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- AUTORIZACIÓN MANUAL MODAL -->
<ng-container *ngIf="code">
  <p-dialog [(visible)]="visibleSigningManualModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
    <div class="dialog">
      <form [formGroup]="form" (ngSubmit)="authorize()">
        <div class="container">
          <div class="wrapper">
            <div class="dialog__info">
              <h2>Confirmación</h2>
              <p>Validamos tu número de documento y te asignamos un <strong>código de verificación</strong>:</p>
            </div>

            <div class="dialog__block">
              <div class="IDCodeContent">
                <div class="IDCode"><span>{{ code }}</span></div>
                <p class="big pt-20">Por favor, <strong>ingresa</strong> a continuación el código de 4 dígitos anterior y confirma tu firma digital presionando el boton <strong>“Firmar”</strong></p>
              </div>
            </div>

            <div class="dialog__form">
              <div class="form__group form__group--codeNumber" [ngClass]="{'form__error': submitted && f['code'].errors}">
                <input pInputText type="text" formControlName="code" maxlength="4">

                <span class="form__msgError form__msgError--center" *ngIf="(submitted || f['code'].touched ) && f['code'].errors">
                  <small class="p-error" *ngIf="f['code'].getError('required')">{{ "El Código" | required }}</small>
                  <small class="p-error" *ngIf="f['code'].getError('invalid')">{{ "El Código" | invalid }}</small>
                </span>

                <span class="form__msgValidate form__msgValidate--center" *ngIf="f['code'].pending">
                  <small class="p-validate">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Validando código...</span>
                  </small>
                </span>
              </div>
            </div>

            <div class="dialog__btn">
              <button pButton pRipple type="submit" label="Autorizar" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="form.invalid"></button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </p-dialog>
</ng-container>
